import style from './index.module.css'

import React from 'react'

import { Flex, Text, Tooltip } from 'components/ds'
import HighlightedText from 'components/ui/highlighted-text'

import CheckboxRow from './checkbox-row'

export const CheckboxContainer: React.FC<{
  containerName: string
  children: React.ReactNode
}> = ({ containerName, children }): React.ReactElement => {
  const isTruncated = Boolean(containerName && containerName.length > 25)
  const content = isTruncated ? (
    <Tooltip side="left" content={containerName}>
      {children}
    </Tooltip>
  ) : (
    children
  )
  return (
    <Flex width="100%" maxWidth="240px">
      {content}
    </Flex>
  )
}

export const CheckboxContent = ({
  indentedSpace,
  itemName,
  searchValue,
}): React.ReactNode => {
  return (
    <Flex maxWidth="200px" width={`calc(200px - ${indentedSpace + 10}px)`}>
      <Text truncate>
        <HighlightedText
          text={itemName}
          highlights={searchValue ? [searchValue] : []}
          customColors={{
            background: 'var(--disco-yellow',
          }}
        />
      </Text>
    </Flex>
  )
}

type CheckboxItemProps = {
  item: any
  onSelected: (_group: any) => boolean
  handleSelection: (
    _checked: string | boolean,
    _group: any,
    _event?: React.MouseEvent,
  ) => void
  searchValue: string
  indentedSpace: number
  isChecked?: boolean
}

export const CheckboxItem = ({
  item,
  onSelected,
  handleSelection,
  searchValue,
  indentedSpace,
  isChecked = false,
}: CheckboxItemProps): React.ReactNode => {
  const checked = isChecked ? true : 'indeterminate'
  return (
    <Flex key={item.id} width="100%" pl={`${indentedSpace}px`}>
      <CheckboxRow
        checked={onSelected(item) ? checked : false}
        disabled={!isChecked && onSelected(item)}
        className={style.Checkbox_RowContainer}
        onCheckedChange={checked => handleSelection(checked, item)}
        onClick={(event: React.MouseEvent) => {
          handleSelection(!onSelected(item), item, event)
        }}
      >
        <CheckboxContent
          indentedSpace={indentedSpace}
          itemName={item.name}
          searchValue={searchValue}
        />
      </CheckboxRow>
    </Flex>
  )
}
